module.exports = __webpack_public_path__ + "assets/img/WB0000.dada6a97.png";